import { cva } from '@/styled-system/css';

export const comboboxOptionLabelRecipe = cva({
  base: {
    display: 'block',
    gridArea: 'label',
    textStyle: 'body',
    color: { base: 'text.action.neutral.default' },
  },
  variants: {
    disabled: {
      true: {},
      false: {
        color: {
          _groupHover: 'text.action.neutral.hover',
          _groupActive: 'text.action.neutral.pressed',
        },
      },
    },
    selected: {
      true: {
        color: { base: 'text.action.neutral.default' },
        textStyle: 'body-bold',
      },
      false: {},
    },
  },
});
